
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { adminAracYetkiBelgesiSorgula } from '../../features/admin2/admin2Slice'
import { showModal } from '../../features/modal/modalSlice'
import Button from '../shared/Button'
import Btn from '../shared/button/Btn'

const Container = styled.div`

  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;

  .content{
    height: calc(100 - 80px);
    display: flex;
    flex-direction: column;

    p{
      font-size: var(--font-size-md);
      font-weight: var(--font-weight-lg);
      color: ${({theme}) => theme.mainTextColor};
    }

    .res-list{
      display: flex;
      flex-direction: column;
      margin: 20px 0;
      gap: 20px;

      .res-item{
        background-color: ${({theme}) => theme.secondaryBgColor};
        border-radius: 10px;
        padding: 15px 25px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);

        span{
          color: var(--color-main);
          font-weight: var(--font-weight-xl);
        }
      }
    }


    
  }

  .btn-container{
    margin-top: auto;
    height: 80px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

const AdminAracYetkiBelgesiSorgula = () => {

  const dispatch = useDispatch()

  const {selectAdminArac, yetkiBelgesiBilgi} = useSelector(state => state.admin2)

  useEffect(() => {
    dispatch(adminAracYetkiBelgesiSorgula(selectAdminArac.type === "truck" ? selectAdminArac.truckPlateNumber : selectAdminArac.trailerPlateNumber))
  },[])

  return (
    <Container>
      <div className="content">
        <p>{selectAdminArac.type === "truck" ? selectAdminArac.truckPlateNumber : selectAdminArac.trailerPlateNumber} Plakalı Aracın Yetki Belgesi Sorgu Sonuçları</p>
        <div className='res-list'>
          <div className="res-item"><span>Firma:</span> {yetkiBelgesiBilgi?.firmaUnvan}</div>
          <div className="res-item"><span>Belge Türü:</span> {yetkiBelgesiBilgi?.belgeTuru}</div>
          <div className="res-item"><span>Geçerlilik Tarihi:</span> {yetkiBelgesiBilgi?.belgeGecerlilikTarihi}</div>
        </div>
      </div>
      <div className="btn-container">
        <Btn handleClick={() => dispatch(showModal(null))} width={"220px"} bgColor="#E85446" borderColor="transparent" color="#fff" padding="10px">Kapat</Btn>
      </div>
    </Container>
  )
}

export default AdminAracYetkiBelgesiSorgula